export const WIKI_SUPPORT = '/general-information/customer-support';
